'use client';

import React from 'react';
import { usePathname } from 'next/navigation';
import AdminLayout from './AdminLayout';

export default function AdminLayoutWrapper({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  if (pathname === '/admin/login') {
    return <>{children}</>;
  }

  return <AdminLayout>{children}</AdminLayout>;
}
